// extracted by mini-css-extract-plugin
module.exports = {"purpleLight":"#f6f1ff","purpleDark":"#674998"};